import React, { useState } from "react";
import styled from "styled-components";
import { PageWrapper } from "Styles";
import DarkHero from "assets/images/dark-hero.png";
import LightHero from "assets/images/light-hero.png";
import { useLayoutContext } from "context/useLayoutContext";
import why1 from "assets/images/why-1.png";
import why2 from "assets/images/why-2.png";
import why3 from "assets/images/why-3.png";
import ellipse from "assets/images/ellipse.png";
import linear from "assets/images/linear.png";
import contact from "assets/images/contact.png";
import { Icon } from "@iconify/react";
import TextFormInput from "components/TextFormInput";
import { useForm } from "react-hook-form";
import TextAreaFormInput from "components/TextAreaInput";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Home = () => {
  const { theme } = useLayoutContext();
  const [isLoading, setIsLoading] = useState(false);

  const { control, handleSubmit, reset } = useForm();
  const handleContactForm = handleSubmit(async (data) => {

    const { first_name, last_name, email, phone_number, message } = data;
    if (!first_name) {
      toast.error("First name is required");
      return;
    }

    if (!last_name) {
      toast.error("Last name is required");
      return;
    }

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Enter a valid email address");
      return;
    }

    if (!phone_number) {
      toast.error("Phone number is required");
      return;
    }

    if (!message) {
      toast.error("Message is required");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/contact-us`,
        data
      );
      toast.success(response?.data?.message);
      reset();
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsLoading(false);
    }
  });

  const choose = [
    {
      image: why1,
      title: "Client-Centered Development",
      subtitle:
        "We involve you at every stage, ensuring your vision is translated into a robust and scalable solution.",
    },
    {
      image: why2,
      title: "Agile methodology",
      subtitle:
        "Our agile development process ensures flexibility and adaptability, allowing us to meet changing requirements and deliver continuous value.GG",
    },
    {
      image: why3,
      title: "Continuous Support",
      subtitle:
        "We offer ongoing maintenance and support to ensure your software stays up-to-date and performs at its best.",
    },
  ];

  const howcards = [
    {
      title: "Discovery & Consultation",
      subtitle:
        "We start by understanding your business, goals, and challenges. Through in-depth consultations, we identify the scope of your project and establish clear objectives.",
      icon: "mingcute:telescope-2-fill",
    },
    {
      title: "Planning & Strategy:",
      subtitle:
        "Based on our findings, we craft a tailored development plan, including timelines, milestones, and technical requirements. We ensure every detail is aligned with your vision before moving forward.",
      icon: "game-icons:chess-queen",
    },
    {
      title: "Design & Prototyping",
      subtitle:
        "Our design team creates intuitive, user-friendly interfaces that enhance the overall user experience. We’ll share prototypes for your feedback, refining the design until it perfectly fits your needs.",
      icon: "ion:logo-figma",
    },
    {
      title: "Development",
      subtitle:
        "Using an agile development methodology, our expert engineers bring the design to life. We build in iterations, ensuring continuous progress, regular updates, and the ability to adapt to any new requirements.",
      icon: "material-symbols:developer-mode-tv",
    },
  ];

  const products = [
    {
      title: "Shelf21",
      subtitle:
        "Shelf21 is a cloud-based school management platform that simplifies administrative workflows—attendance, timetables, grading, assessments, communication, and fee tracking—all in one unified system",
      link: "https://www.shelf21.com/",
      cardBG: "#E6F0FF",
      cardLink: "#013EBA",
    },
    {
      title: "SLOT Finance",
      subtitle:
        "SLOT Finance is an app that digitises traditional rotating savings clubs (e.g., Ajo, Tontine). It emphasises community, safety, transparency, convenience and combining automated contributions making savings more convenient",
      link: "https://www.slotfinance.co/",
      cardBG: "#E7F5EC",
      cardLink: "#0EDC96",
    },
  ];
  return (
    <Wrapper>
      <PageWrapper>
        <HeroBackground>
          <HeroText>
            Corpine Solutions for high performing teams. Turn Ideas to Products.
          </HeroText>
          <HeroSubText>
            Partner with us to turn your vision into reality. We craft innovative, user-focused software solutions that not only meet your customers' needs but also drive tangible growth and profitability for your business. <br/> <br/>Your ideas deserve more than inspiration — they deserve execution. We are your trusted technology partner.


          </HeroSubText>
          {theme === "dark" ? (
            <img src={DarkHero} alt="dark-hero" />
          ) : (
            <img src={LightHero} alt="dark-hero" />
          )}
        </HeroBackground>

        {/* Why Choose us */}
        <SectionContainer left className="about">
          <Pill>Our Approach</Pill>
          <SectionTitle>Why Choose Us?</SectionTitle>
          <SectionSubTitle>
            At Corpine, we prioritise delivering high-quality software solutions
            tailored to your business needs. Our approach is centered around
            collaboration, innovation, and efficiency:
          </SectionSubTitle>

          <WhyCardsWrapper>
            {choose?.map((item, i) => {
              return (
                <WhyCards key={i}>
                  <WhyCardTop>
                    <img src={item?.image} alt="" />
                  </WhyCardTop>
                  <WhyCardBottom>
                    <h6>{item?.title}</h6>
                    <p>{item?.subtitle}</p>
                  </WhyCardBottom>
                </WhyCards>
              );
            })}
          </WhyCardsWrapper>
        </SectionContainer>

        {/* Why Choose us */}
        <SectionContainer center className="services">
          <SectionTitle>How We Work?</SectionTitle>
          <SectionSubTitle width="60%">
            At Corpine, our process is designed to deliver top-notch software
            solutions efficiently and transparently. We follow a structured, yet
            flexible approach to ensure every project meets your goals and
            exceeds your expectations.
          </SectionSubTitle>
          <HowSection>
            {howcards?.map((item, i) => {
              return (
                <HowCards key={i}>
                  <StyledHowIcons>
                    <Icon icon={item?.icon} />
                  </StyledHowIcons>
                  <h6>{item?.title}</h6>
                  <p>{item?.subtitle}</p>
                </HowCards>
              );
            })}
          </HowSection>
        </SectionContainer>

        {/* Our Products */}
        <SectionContainer center>
          <Pill center>Our Products</Pill>
          <SectionTitle>
            See Some of Our Products Available for Use.?
          </SectionTitle>
          <SectionSubTitle width="80%">
            Explore a curated selection of our live products, each thoughtfully designed to simplify operations, boost efficiency, and deliver real value to your business or organization.
          </SectionSubTitle>
          <ProductSection>
            {products?.map((item, i) => {
              return (
                <ProductCardContainer border={item?.cardLink} key={i}>
                  <ProductCard bg={item?.cardBG}>
                    <h6>{item?.title}</h6>
                    <p>{item?.subtitle}</p>
                    <ProductLink
                      href={item?.link}
                      target="blank"
                      color={item?.cardLink}
                    >
                      Learn More{" "}
                      <span>
                        <Icon icon="fluent:window-new-16-filled" />
                      </span>
                    </ProductLink>
                  </ProductCard>
                </ProductCardContainer>
              );
            })}
          </ProductSection>
        </SectionContainer>
      </PageWrapper>
      <ContactWrapper className="contact">
        <PageWrapper>
          <ContactCardContainer>
            <ContactCard>
              <div>
                <img src={contact} alt="contact" />
                <h4>
                  Our design team creates intuitive, user-friendly interfaces
                  that enhance the overall user experience. We’ll share
                  prototypes for your feedback, refining the design until it
                  perfectly fits your needs.
                </h4>
              </div>
            </ContactCard>
            <ContactCard>
              <FormContainer onSubmit={handleContactForm}>
                <h3>Get in touch</h3>
                <h6>Send a message to the corpine team</h6>
                <ContactForm>
                  <TextFormInput
                    type="text"
                    inputWidth="50%"
                    label="First Name"
                    name="first_name"
                    control={control}
                    className="form-control  form-group mb-2"
                  />
                  <TextFormInput
                    type="text"
                    inputWidth="50%"
                    label="Last Name"
                    name="last_name"
                    control={control}
                    className="form-control  form-group mb-2"
                  />
                  <TextFormInput
                    type="number"
                    inputWidth="50%"
                    label="Phone Number"
                    name="phone_number"
                    control={control}
                    className="form-control  form-group mb-2"
                  />
                  <TextFormInput
                    type="text"
                    inputWidth="50%"
                    label="Email Address"
                    name="email"
                    control={control}
                    className="form-control  form-group mb-2"
                  />
                  <TextAreaFormInput
                    rows={10}
                    cells={12}
                    label="Message"
                    name="message"
                    control={control}
                    className="form-control  form-group mb-2"
                  />
                </ContactForm>
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Send Message"}
                </button>
              </FormContainer>
            </ContactCard>
          </ContactCardContainer>
        </PageWrapper>
      </ContactWrapper>
      <ToastContainer/>
    </Wrapper>
  );
};

export default Home;

const Wrapper = styled.div`
  padding-top: 80px;
  position: relative;
`;

const HeroBackground = styled.div`
  text-align: center;
  position: relative;
  background: ${({ theme }) =>
    `linear-gradient(to bottom, ${theme.startColor} 0%, ${theme.midColor} 46%, ${theme.endColor} 100%)`};
  box-sizing: border-box;
  padding-top: 89px;
  padding-left: 35px;
  padding-right: 35px;
  border-radius: 16px 16px 0px 0px;

  @media (min-width: 1366px) {
    width: 1300px;
    margin: auto;
    margin-top: 49px;
    img {
      width: 100%;
    }
  }

  @media (max-width: 1366px) {
    width: 100%;
    box-sizing: border-box;
    margin-top: 49px;
    img {
      width: 95%;
    }
  }

  @media (max-width: 576px) {
    padding-top: 45px;
    img {
      width: 100%;
    }
  }
  @media (max-width: 576px) {
    padding-left: 14px;
    padding-right: 14px;
    img {
      margin-left: -30px;
      width: calc(100% + 60px);
    }
  }
`;

const HeroText = styled.h1`
  font-size: 46px;
  line-height: 1.2em;
  width: 781px;
  margin: auto;
  font-weight: 500;
  margin-bottom: 16px;

  @media (max-width: 1200px) {
    font-size: 48px;
  }

  @media (max-width: 991px) {
    font-size: 36px;
    width: 90%;
  }

  @media (max-width: 576px) {
    font-size: 26px;
    font-weight: 400;
    width: 90%;
  }
`;

const HeroSubText = styled.p`
  font-size: 18px;
  width: 571px;
  margin: auto;
  line-height: 1.5em;
  margin-bottom: 54px;

  @media (max-width: 768px) {
    width: 90%;
    font-size: 16px;
  }
`;

const Pill = styled.div`
  background-color: #e6f0ff;
  color: #013eba;
  border-radius: 54px;
  font-size: 14px;
  padding: 8px 16px;
  width: 129px;
  text-align: center;
  box-sizing: border-box;
  margin: ${(props) => props.center && "auto"};

  @media (max-width: 768px) {
    margin: auto;
  }
`;

const SectionContainer = styled.div`
  padding-top: 72px;
  padding-bottom: 72px;
  text-align: ${(props) =>
    props.center ? "center" : props?.left ? "left" : "right"};

  @media (max-width: 768px) {
    padding-bottom: 30px;
  }

  @media (max-width: 576px) {
    padding-top: 45px;
    padding-bottom: 45px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 32px;
  font-weight: 500;
  margin-top: 12px;
  margin-bottom: 12px;
  @media (max-width: 768px) {
    width: 75%;
    margin: auto;
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 26px;
    text-align: center;
  }
  @media (max-width: 576px) {
    font-size: 20px;
    text-align: center;
    width: 100%;
  }
`;

const SectionSubTitle = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4em;
  margin: auto;
  margin-top: 0px;
  margin-bottom: 24px;
  width: ${(props) => props.width || "100%"};

  @media (max-width: 768px) {
    width: 75%;
    margin: auto;
    margin-bottom: 24px;
  }
  @media (max-width: 576px) {
    font-size: 16px;
    margin-bottom: 24px;
    text-align: center;
  }

  @media (max-width: 426px) {
    width: 100%;
  }
`;

const WhyCardsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5%;

  @media (max-width: 1366px) {
    gap: 30px;
  }

  @media (max-width: 991px) {
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const WhyCards = styled.div`
  width: 30%;
  height: 480px;
  border-radius: 16px;
  padding: 23px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.cardbody};

  img {
    width: 100%;
  }
  @media (max-width: 1366px) {
    width: 32%;
  }
  @media (max-width: 991px) {
    width: 47%;
    gap: 1%;
  }

  @media (max-width: 768px) {
    width: 75%;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    height: 420px;
  }
`;

const WhyCardTop = styled.div`
  background-color: ${({ theme }) => theme.cardbg};
  padding: 22px;
  box-sizing: border-box;
  height: 272px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  @media (max-width: 576px) {
    padding: 15px;
  }
  @media (max-width: 576px) {
    height: 220px;
  }
`;

const WhyCardBottom = styled.div`
  margin-top: 18px;
  h6 {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  p {
    font-size: 16px;
    line-height: 1.4em;
    margin-top: 8px;
    margin-bottom: 0px;
  }

  @media (max-width: 576px) {
    h6 {
      font-size: 20px;
    }
  }
`;

const HowSection = styled.div`
  height: 700px;
  background-image: url(${ellipse});
  background-size: auto 70%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 1200px) {
    height: 90%;
  }

  @media (max-width: 768px) {
    background-image: url(${linear});
    gap: 35px;
  }
`;

const HowCards = styled.div`
  width: 513px;
  height: 242px;
  padding: 24px 40px;
  box-sizing: border-box;
  text-align: left;
  margin-top: 40px;
  margin-bottom: 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.cardbody};
  border: ${({ theme }) => `1px solid ${theme.cardStroke}`};
  h6 {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  p {
    font-size: 14px;
    line-height: 1.4em;
    margin-top: 8px;
    margin-bottom: 0px;
  }

  @media (max-width: 1200px) {
    width: 46%;
    gap: 30px;
  }

  @media (max-width: 991px) {
    padding: 15px 28px;
  }

  @media (max-width: 768px) {
    width: 75%;
    margin: auto;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`;

const StyledHowIcons = styled.div`
  width: 36px;
  height: 36px;
  font-size: 24px;
  border-radius: 50%;
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: center;
  color: #33d49d;
  background-color: #e3fff1;
  border: 1px solid 33D49D;
`;

const ProductSection = styled.div`
  display: flex;
  gap: 4%;
  justify-content: space-between;
  padding-top: 50px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding-top: 0px;
    gap: 30px;
  }
`;

const ProductCardContainer = styled.div`
  width: 48%;
  box-sizing: border-box;
  padding: 34px 37px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.cardbody};
  border: ${(props) => `1px solid ${props.border}`};
  @media (max-width: 768px) {
    width: 75%;
    margin: auto;
  }
  @media (max-width: 576px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    padding: 15px;
  }
`;

const ProductCard = styled.div`
  padding: 24px;
  box-sizing: border-box;
  text-align: left;
  border-radius: 16px;
  background-color: ${(props) => props.bg};
  color: black;
  h6 {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 0px;
    font-weight: 600;
  }
  p {
    font-size: 16px;
    line-height: 1.4em;
    margin-top: 8px;
    margin-bottom: 0px;
  }
  span {
    margin-right: 10px;
  }
`;

const ProductLink = styled.a`
  font-size: 16px;
  line-height: 1.4em;
  display: inline-block;
  padding-top: 8px;
  font-weight: 600;
  text-decoration: none;
  color: ${(props) => props.color} !important;
`;

const ContactWrapper = styled.div`
  width: 100%;
  padding-top: 38px;
  padding-bottom: 38px;
  background-color: ${({ theme }) => theme.cardbody};
`;

const ContactCardContainer = styled.div`
  display: flex;
  gap: 48px;
  @media (max-width: 1200px) {
    gap: 30px;
  }
`;

const ContactCard = styled.div`
  height: 700px;
  width: 50%;
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.cardbg};
  display: flex;
  align-items: center;
  img {
    width: 100%;
  }
  h4 {
    font-size: 16px;
    line-height: 1.4em;
    margin-top: 8px;
    margin-bottom: 15px;
    font-weight: 400;
    text-align: center;
  }
  @media (max-width: 991px) {
    &:first-child {
      display: none;
    }
    &:last-child {
      width: 75%;
      margin: auto;
    }
  }
  @media (max-width: 768px) {
    &:last-child {
      width: 100%;
    }
  }
  @media (max-width: 476px) {
    height: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

const FormContainer = styled.form`
  width: 100%;
  h3 {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 0px;
    margin-top: 0px;
    font-weight: 600;
  }
  h6 {
    font-size: 16px;
    line-height: 1.4em;
    margin-top: 8px;
    margin-bottom: 15pxpx;
    font-weight: 400;
  }
  button {
    background-color: #013eba;
    width: 65%;
    margin: auto;
    margin-top: 20px;
    color: white;
    font-size: 16px;
    border: none;
    outline: 0;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ContactForm = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  @media (max-width: 476px) {
    div {
      width: 100% !important;
    }
  }
`;
